import { Component, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { ResponsiveService } from '../../services/responsive.service';
import { TranslatorService } from '../../services/translator_service';
import { switchMap, filter, distinctUntilChanged, Subject, combineLatest, BehaviorSubject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { ApiQuery } from '../../web-services/api/api.query';
import { ActivatedRoute, RouterModule } from '@angular/router';
import _ from 'lodash';
import moment from 'moment';
import { UtilService } from '../../services/util.service';
import { ApiStore } from '../../web-services/api/api.store';
import { ResolveTicketModal } from '../ticket-management/resolve-ticket-modal/resolve-ticket-modal';
import { MatDialog } from '@angular/material/dialog';
import { ViewTicketModal } from '../ticket-management/view-ticket-modal/view-ticket-modal';
import { TranslatePipe } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Pagination } from '../pagination/pagination';
import { RTLDivDirectiveDirective } from '../../directives/rtldiv-directive.directive';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TableUtil } from '../../tableUtil';
import { AddTicketModal } from './add-ticket-modal/add-ticket-modal';
import { BinLiveInfoModal } from '../bin-live-info-modal/bin-live-info-modal';
import { ApiService } from '../../web-services/api/api.service';
import { EditTicketModal } from '../ticket-management/edit-ticket-modal/edit-ticket-modal';
import { TechnicianTicketManagementMap } from './technician-ticket-management-map/technician-ticket-management-map';
import { GenericColumnsManagingModal } from '../generic-columns-managing-modal/generic-columns-managing-modal';
import { FilterBar } from '../filter-bar/filter-bar';

@Component({
  selector: 'app-technician-ticket-management',
  imports: [TranslatePipe,CommonModule,Pagination,RTLDivDirectiveDirective,MatTableModule,MatSortModule,
    NgbModule,RouterModule,TechnicianTicketManagementMap,FilterBar],  
  templateUrl: './technician-ticket-management.html',
  styleUrl: './technician-ticket-management.scss',
})
export class TechnicianTicketManagement {
  expandedElement: any;
  technicianTickets$ = new BehaviorSubject<any[]>([]);
  @ViewChild(MatSort,{static: false}) sort: MatSort;
  isMobile: boolean;
	private readonly destroy$ = new Subject<void>();
	currentLang;
	translationsObj;
	ticketId:any;
	openedTickets:Array<object> = [];
	closedTickets:Array<object> = [];
	private isResolveDialogOpen: boolean = false;
	usageType = 1;
	user_role_id = 0;
	user_id = 0;
	markerSelected:object = {};
	expandedElementTable: object = {};
  mapTechnicianExpanded:boolean = false;

  currentFilteredTechnicianTicketsArr: any[] = null;
  currentTechnicianTicketsFilterValues: any = null;
  technicianTickets:Array<object> = [];
	technicianTicketsTableLength = 0;
	technicianTicketsDataSource = new MatTableDataSource<any>();
	tempTechnicianTicketsFilter:any = '';
	startIndexTableDataTechnicianTickets = 0;
	endIndexTableDataTechnicianTickets = 9;
	displayedTechnicianTicketsColumns = ['ticket_type','ticket_id','ticket_status','event_cause','priority','site_name','bin_name','bin_address','comment','assignee','reporter','created','arrival_date','closed','removedReason','manage'];
	technicianTicketsColumnsToDisplay = ['ticket_status', 'event_cause','arrival_date','ticket_type','ticket_id','priority','site_name','bin_name','bin_address','comment','assignee','reporter','created','closed','removedReason', 'arrowDown'];
	technicianTicketsSpinnerActive:boolean = true;
	filteredTechnicianTicketsData:Array<object> = [];
	mapTechnicianTicketsExpanded:boolean = false;

	ticketManagementTechnicianTicketsSelectedValues = {
    isTicketTypeChecked: false,
		isTicketIdChecked: false,
		isTicketStatusChecked: false,
		isTicketCauseChecked: false,
		isTicketPriorityChecked: false,
		isTicketSiteChecked: false,
		isBinNameChecked: false,
		isTicketAddressChecked: false,
		isDescChecked: false,
    isAssigneeChecked: false,
		isReporterChecked: false,
		isTicketCreatedChecked: false,
		isArrivalDateChecked: false,
		isTicketClosedChecked: false,
		isRemovedReasonChecked: false 
	};

  constructor(private apiQuery:ApiQuery,private translator: TranslatorService,private responsiveService: ResponsiveService,
    private utilService: UtilService,private route: ActivatedRoute,private apiStore:ApiStore,private dialog: MatDialog,
    private apiService:ApiService
  ) {
  }

  ngOnInit() {
    this.onResize();
	  this.responsiveService.checkWidth(); 

    this.apiQuery.user$.pipe(takeUntil(this.destroy$)).subscribe(user => {
      if (!user) {
        return;
      }		
      if(user["usage_type_id"] != 1){
        this.usageType = user["usage_type_id"];
      }	
      this.user_role_id = user["user_role_id"];
      this.user_id = user["user_id"];
  
      if(this.usageType == 1){
        this.ticketManagementTechnicianTicketsSelectedValues.isTicketStatusChecked = true;
        this.ticketManagementTechnicianTicketsSelectedValues.isTicketSiteChecked = true;
      }else{
      }
    });  
    this.initTables();
  }

  handleExpandedElm(elm){
    if(this.expandedElementTable["ticket_id"] != elm["ticket_id"]){
      this.expandedElementTable = elm;
    }else{
      this.markerSelected = {};
      this.expandedElementTable = {};
    }
  }

  initTables(){
    this.translator.currentLangEmitter$
    .pipe(
      takeUntil(this.destroy$),
      filter((lang: any) => !!lang),
      distinctUntilChanged(),
      switchMap((lang: any) =>
      this.translator.getTranslation(lang).pipe(
        tap((dict: any) => {
        this.currentLang = lang;
        this.translationsObj = dict;
        })
      )
      ),
      switchMap(() =>
      this.route.queryParams.pipe(
        tap(() => {
        this.ticketId = this.route.snapshot.paramMap.get("id");
        })
      )
      ),
      switchMap(() =>
      combineLatest([
        this.apiQuery.cRTicketsList$,
        this.apiQuery.insTicketsList$,
        this.apiQuery.rmTicketsList$,
        this.apiQuery.filteredBasicBins$
      ])
      )
    )
    .pipe(takeUntil(this.destroy$))
    .subscribe(([cRTicketsList,insTicketsList,rmTicketsList,bins])=>{	
      let technicianTickets = [];	
  
      this.openedTickets = [];
      this.closedTickets = [];
      this.expandedElementTable = {};
      this.markerSelected = {};
  
      this.technicianTicketsSpinnerActive = true;

      if(cRTicketsList.length == 0 || insTicketsList.length == 0 || rmTicketsList.length == 0){return;}
      this.technicianTicketsSpinnerActive = false;
      
      const binsLookup = this.buildBinsLookup(bins);
      _.each(cRTicketsList, (item) => {					
        if(item["TicketsList"]){
          if(item["TicketsList"]["open"]!=null){			
            _.each(item["TicketsList"]["open"], (ticket) => {	
              ticket.site_name = item["site_name"];
              ticket.site_id = item["site_id"];
              ticket.status = 1;
              this.getRelevantBin(binsLookup,ticket,"1");
              technicianTickets.push(ticket);		
            });		
          }
          if(item["TicketsList"]["close"]!=null){			
            _.each(item["TicketsList"]["close"], (ticket) => {	
              ticket.site_name = item["site_name"];
              ticket.site_id = item["site_id"];
              ticket.status = 4;
              this.getRelevantBin(binsLookup,ticket,"4");
              technicianTickets.push(ticket);		
            });		
          }		
          if(item["TicketsList"]["on hold"]!=null){			
            _.each(item["TicketsList"]["on hold"], (ticket) => {	
              ticket.site_name = item["site_name"];
              ticket.site_id = item["site_id"];
              ticket.status = 3;
              this.getRelevantBin(binsLookup,ticket,"3");
              technicianTickets.push(ticket);		
            });								
          }	
        }		
      });
  
      _.each(insTicketsList, (item) => {					
        if(item["TicketsList"]){
          if(item["TicketsList"]["open"]!=null){			
            _.each(item["TicketsList"]["open"], (ticket) => {	
              ticket.site_name = item["site_name"];
              ticket.site_id = item["site_id"];
              ticket.status = 1;
              this.getRelevantBin(binsLookup,ticket,"1");
              technicianTickets.push(ticket);	
            });		
          }
          if(item["TicketsList"]["close"]!=null){
            _.each(item["TicketsList"]["close"], (ticket) => {	
              ticket.site_name = item["site_name"];
              ticket.site_id = item["site_id"];
              ticket.status = 4;
              this.getRelevantBin(binsLookup,ticket,"4");
              technicianTickets.push(ticket);	
            });	
          }
          if(item["TicketsList"]["on hold"]!=null){			
            _.each(item["TicketsList"]["on hold"], (ticket) => {	
              ticket.site_name = item["site_name"];
              ticket.site_id = item["site_id"];
              ticket.status = 3;
              this.getRelevantBin(binsLookup,ticket,"3");
              technicianTickets.push(ticket);		
            });	
          }										
        }		
      });
  
      _.each(rmTicketsList, (item) => {					
        if(item["TicketsList"]){
          if(item["TicketsList"]["open"]!=null){			
            _.each(item["TicketsList"]["open"], (ticket) => {	
              ticket.site_name = item["site_name"];
              ticket.site_id = item["site_id"];
              ticket.status = 1;
              this.getRelevantBin(binsLookup,ticket,"1");
              technicianTickets.push(ticket);	
            });		
          }
          if(item["TicketsList"]["close"]!=null){
            _.each(item["TicketsList"]["close"], (ticket) => {	
              ticket.site_name = item["site_name"];
              ticket.site_id = item["site_id"];
              ticket.status = 4;
              this.getRelevantBin(binsLookup,ticket,"4");
              technicianTickets.push(ticket);	
            });	
          }
          if(item["TicketsList"]["on hold"]!=null){			
            _.each(item["TicketsList"]["on hold"], (ticket) => {	
              ticket.site_name = item["site_name"];
              ticket.site_id = item["site_id"];
              ticket.status = 3;
              this.getRelevantBin(binsLookup,ticket,"3");
              technicianTickets.push(ticket);		
            });	
          }										
        }		
      });
      const technicianTicketsFiltered = _.map(technicianTickets, ticket => {
        const byStatus = _.groupBy(ticket["ticket_id_info"], "status_id");
        const ticket_event_type_id = ticket["ticketData"].ticket_event_type_id;
        if(ticket_event_type_id == 1){
          return {
            ticket_type : ticket["ticketData"].ticket_event_type_name,
            ticket_id : ticket["ticket_id"],
            status_txt : ticket["status"] == 1 ? this.translationsObj.TICKET_MANAGEMENT.OPENED : ticket["status"] == 3 ? this.translationsObj.TICKET_MANAGEMENT.ON_HOLD_STATUS : this.translationsObj.TICKET_MANAGEMENT.CLOSED_STATUS,
            eventCauseEn : ticket["ticketData"].ticket_event_cause_name,
            priorityEn : ticket["ticketData"].priority_name,
            site_name : ticket["site_name"],
            bin_name : ticket["status"] == 1 ? (byStatus["1"] ? (ticket["ticketData"].ticket_event_type_id == 3 ? byStatus["1"][byStatus["1"].length - 1].installed_bin_name : byStatus["1"][byStatus["1"].length - 1].bin_name) : '') : ticket["status"] == 3 ? (byStatus["3"] ? (ticket["ticketData"].ticket_event_type_id == 3 ? byStatus["3"][byStatus["3"].length - 1].installed_bin_name : byStatus["3"][byStatus["3"].length - 1].bin_name) : '') : (byStatus["4"] ? (ticket["ticketData"].ticket_event_type_id == 3 ? byStatus["4"][byStatus["4"].length - 1].installed_bin_name : byStatus["4"][byStatus["4"].length - 1].bin_name) : ''),
            bin_address : ticket["status"] == 1 ? (byStatus["1"] ? (ticket["ticketData"].ticket_event_type_id == 3 ? byStatus["1"][byStatus["1"].length - 1].installed_bin_address : byStatus["1"][byStatus["1"].length - 1].bin_address) : '') : ticket["status"] == 3 ? (byStatus["3"] ? (ticket["ticketData"].ticket_event_type_id == 3 ? byStatus["3"][byStatus["3"].length - 1].installed_bin_address : byStatus["3"][byStatus["3"].length - 1].bin_address) : '') : (byStatus["4"] ? (ticket["ticketData"].ticket_event_type_id == 3 ? byStatus["4"][byStatus["4"].length - 1].installed_bin_address : byStatus["4"][byStatus["4"].length - 1].bin_address) : ''),
            comment : byStatus["1"] ? byStatus["1"][byStatus["1"].length - 1].comment : '',
            assignee : byStatus[ticket["status"]] ? byStatus[ticket["status"]][byStatus[ticket["status"]].length - 1].assigned_user_first_name + " " + byStatus[ticket["status"]][byStatus[ticket["status"]].length - 1].assigned_user_last_name : '',
            reporter : byStatus["1"] ? (byStatus["1"][0].user_first_name != null && byStatus["1"][0].user_last_name != null ? byStatus["1"][0].user_first_name + " " + byStatus["1"][0].user_last_name : this.translationsObj.TICKET_MANAGEMENT.AUTOMATIC_TICKET) : '',
            created : ticket["ticket_id_info"].length > 0 ? this.utilService.convertDateEnglishWithoutTime(ticket["ticket_id_info"][0].action_time) : '',
            expected_arrival_date : this.utilService.convertDateEnglishWithoutTime(ticket["ticketData"].expected_arrival_date == '0000-00-00 00:00:00' ? (ticket["ticketData"].priority_id == 3 ? moment().add(1,'weeks').format('YYYY-MM-DD HH:mm:ss') : moment().add(2,'weeks').format('YYYY-MM-DD HH:mm:ss')) : moment(ticket["ticketData"].expected_arrival_date).format('YYYY-MM-DD HH:mm:ss')),
            closed : this.utilService.convertDateEnglish(ticket["status"] == 1 ? '' : (byStatus["4"] ? byStatus["4"][0].action_time : '')),
            reasonOfReplacementEn : ticket["status"] == 1 ? '' : byStatus[4]?.[byStatus[4]?.length - 1].ticket_remove_replace_cause_name ? byStatus[4]?.[byStatus[4]?.length - 1].ticket_remove_replace_cause_name : byStatus[4]?.[byStatus[4]?.length - 1].replace_cause_name,            
            resolvedDescription : byStatus["4"] ? byStatus["4"][byStatus["4"].length - 1].comment : '',
            analysisNameEn : ticket["status"] == 1 ? '' : byStatus[4]?.[byStatus[4]?.length - 1].analysis_name,
            is_replaced_csv:'',
            eventCauseHe : ticket["ticketData"].ticket_event_cause_name_hebrew,
            priorityHe : ticket["ticketData"].priority_name_hebrew,
            site_id : ticket["site_id"],
            ticket_event_cause_id : ticket["ticketData"].ticket_event_cause_id,
            priority_id : ticket["ticketData"].priority_id,
            ticket_event_type_id : ticket["ticketData"].ticket_event_type_id,
            ticketInfo : ticket["ticket_id_info"],
            pic_url : ticket["ticketData"].pic_url,
            first_name : byStatus["1"] ? byStatus["1"][0].user_first_name : '',
            last_name : byStatus["1"] ? byStatus["1"][0].user_last_name: '',
            user_id : ticket["status"] == 1 ? (byStatus["1"] ? byStatus["1"][byStatus["1"].length - 1].user_id: '') : (byStatus["4"] ? byStatus["4"][byStatus["4"].length - 1].user_id : ''),
            bin_id : ticket["bin_id"],
            bin_lat : ticket["bin_lat"],
            bin_lon :  ticket["bin_lon"],
            bin_collection_mode : ticket["bin_collection_mode"],
            ticket_type_hebrew : ticket["ticketData"].ticket_event_type_name_hebrew,
            eventTypeEn : ticket["ticketData"].ticket_event_type_name,
            eventTypeHe : ticket["ticketData"].ticket_event_type_name_hebrew,
            status : ticket["status"],
            created_he : ticket["ticket_id_info"].length > 0 ? this.utilService.convertDateHebrewWithoutTime(ticket["ticket_id_info"][0].action_time):'',
            expected_arrival_date_he : this.utilService.convertDateHebrewWithoutTime(ticket["ticketData"].expected_arrival_date == '0000-00-00 00:00:00' ? (ticket["ticketData"].priority_id == 3 ? moment().add(1,'weeks').format('YYYY-MM-DD HH:mm:ss') : moment().add(2,'weeks').format('YYYY-MM-DD HH:mm:ss')) : moment(ticket["ticketData"].expected_arrival_date).format('YYYY-MM-DD HH:mm:ss')),
            closed_he : this.utilService.convertDateHebrew(ticket["status"] == 1 ? '' : (byStatus["4"] ? byStatus["4"][0].action_time : '')),
            created_DateTime_value : ticket["ticket_id_info"].length > 0 ? moment(ticket["ticket_id_info"][0].action_time).format("YYYY-MM-DD HH:mm:ss").valueOf() : '',
            closed_DateTime_value : ticket["status"] == 1 ? '' : (byStatus["4"] ? byStatus["4"][0].action_time : ''),
            created_convertDateEnglish : ticket["ticket_id_info"].length > 0 ? this.utilService.convertDateEnglish(ticket["ticket_id_info"][0].action_time) : '',
            created_convertDateHebrew : ticket["ticket_id_info"].length > 0 ? this.utilService.convertDateHebrew(ticket["ticket_id_info"][0].action_time) : '',
            includedInWorkplan : ticket.includedInWorkplan,
            is_replaced : ticket["status"] == 1 ? '' : byStatus[4]?.[byStatus[4]?.length - 1].is_replaced,
            analysisNameHe : ticket["status"] == 1 ? '' : byStatus[4]?.[byStatus[4]?.length - 1].analysis_name_hebrew,
            reasonOfReplacementID : ticket["status"] == 1 ? '' : byStatus[4]?.[byStatus[4]?.length - 1].ticket_remove_replace_cause_name ? byStatus[4]?.[byStatus[4]?.length - 1].ticket_remove_replace_cause_name : byStatus[4]?.[byStatus[4]?.length - 1].replace_cause_id,
            reasonOfReplacementHe : ticket["status"] == 1 ? '' : byStatus[4]?.[byStatus[4]?.length - 1].ticket_remove_replace_cause_name_hebrew ? byStatus[4]?.[byStatus[4]?.length - 1].ticket_remove_replace_cause_name_hebrew : byStatus[4]?.[byStatus[4]?.length - 1].replace_cause_name_hebrew,
            assigned_user_first_name : byStatus[ticket["status"]] ? byStatus[ticket["status"]][byStatus[ticket["status"]].length - 1].assigned_user_first_name : '',
            assigned_user_last_name : byStatus[ticket["status"]] ? byStatus[ticket["status"]][byStatus[ticket["status"]].length - 1].assigned_user_last_name : ''
          };
        }else if(ticket_event_type_id == 3){
          return {
            ticket_type : ticket["ticketData"].ticket_event_type_name,
            ticket_id : ticket["ticket_id"],
            status_txt : ticket["status"] == 1 ? this.translationsObj.TICKET_MANAGEMENT.OPENED : ticket["status"] == 3 ? this.translationsObj.TICKET_MANAGEMENT.ON_HOLD_STATUS : this.translationsObj.TICKET_MANAGEMENT.CLOSED_STATUS,
            eventCauseEn : ticket["ticketData"].ticket_event_cause_name,
            priorityEn : ticket["ticketData"].priority_name,
            site_name : ticket["site_name"],
            bin_name : ticket["status"] == 1 ? (byStatus["1"] ? (ticket["ticketData"].ticket_event_type_id == 3 ? byStatus["1"][byStatus["1"].length - 1].installed_bin_name : byStatus["1"][byStatus["1"].length - 1].bin_name) : '') : ticket["status"] == 3 ? (byStatus["3"] ? (ticket["ticketData"].ticket_event_type_id == 3 ? byStatus["3"][byStatus["3"].length - 1].installed_bin_name : byStatus["3"][byStatus["3"].length - 1].bin_name) : '') : (byStatus["4"] ? (ticket["ticketData"].ticket_event_type_id == 3 ? byStatus["4"][byStatus["4"].length - 1].installed_bin_name : byStatus["4"][byStatus["4"].length - 1].bin_name) : ''),
            bin_address : ticket["status"] == 1 ? (byStatus["1"] ? (ticket["ticketData"].ticket_event_type_id == 3 ? byStatus["1"][byStatus["1"].length - 1].installed_bin_address : byStatus["1"][byStatus["1"].length - 1].bin_address) : '') : ticket["status"] == 3 ? (byStatus["3"] ? (ticket["ticketData"].ticket_event_type_id == 3 ? byStatus["3"][byStatus["3"].length - 1].installed_bin_address : byStatus["3"][byStatus["3"].length - 1].bin_address) : '') : (byStatus["4"] ? (ticket["ticketData"].ticket_event_type_id == 3 ? byStatus["4"][byStatus["4"].length - 1].installed_bin_address : byStatus["4"][byStatus["4"].length - 1].bin_address) : ''),
            comment : byStatus["1"] ? byStatus["1"][byStatus["1"].length - 1].comment : '',
            assignee : byStatus["1"] ? byStatus["1"][byStatus["1"].length - 1].assigned_user_first_name + " " + byStatus["1"][byStatus["1"].length - 1].assigned_user_last_name : '',
            reporter : byStatus["1"] ? byStatus["1"][0].user_first_name + " " + byStatus["1"][0].user_last_name: this.translationsObj.TICKET_MANAGEMENT.AUTOMATIC_TICKET,
            created : this.utilService.convertDateEnglishWithoutTime(ticket["ticket_id_info"][0].action_time),
            expected_arrival_date : this.utilService.convertDateEnglishWithoutTime(ticket["ticketData"].expected_arrival_date),
            closed : this.utilService.convertDateEnglish(ticket["status"] == 1 ? '' : (byStatus["4"] ? byStatus["4"][0].action_time : '')),            
            resolvedDescription : byStatus["4"] ? byStatus["4"][byStatus["4"].length - 1].comment : '',
            solution_time : moment(moment(byStatus["4"] ? byStatus["4"][0].action_time : '').format('YYYY-MM-DD HH:mm:ss')).diff(moment(ticket["ticket_id_info"][0].action_time).format('YYYY-MM-DD HH:mm:ss'), 'days'),
            eventCauseHe : ticket["ticketData"].ticket_event_cause_name_hebrew,
            priorityHe : ticket["ticketData"].priority_name_hebrew,
            site_id : ticket["site_id"],
            ticket_event_cause_id : ticket["ticketData"].ticket_event_cause_id,
            priority_id : ticket["ticketData"].priority_id,
            ticket_event_type_id : ticket["ticketData"].ticket_event_type_id,
            ticketInfo : ticket["ticket_id_info"],
            pic_url : ticket["ticketData"].pic_url,
            first_name : byStatus["1"] ? byStatus["1"][0].user_first_name : '',
            last_name : byStatus["1"] ? byStatus["1"][0].user_last_name: '',
            user_id : ticket["status"] == 1 ? (byStatus["1"] ? byStatus["1"][byStatus["1"].length - 1].user_id: '') : (byStatus["4"] ? byStatus["4"][byStatus["4"].length - 1].user_id : ''),
            bin_id : ticket["bin_id"],
            eventTypeEn : ticket["ticketData"].ticket_event_type_name,
            eventTypeHe : ticket["ticketData"].ticket_event_type_name_hebrew,
            bin_lat : byStatus["1"] ? byStatus["1"][byStatus["1"].length - 1].installed_lat : 0,
            bin_lon : byStatus["1"] ? byStatus["1"][byStatus["1"].length - 1].installed_lon : 0,
            ticket_type_hebrew : ticket["ticketData"].ticket_event_type_name_hebrew,
            bin_collection_mode : ticket["bin_collection_mode"],
            status : ticket["status"],
            created_he : this.utilService.convertDateHebrewWithoutTime(ticket["ticket_id_info"][0].action_time),
            expected_arrival_date_he : this.utilService.convertDateHebrewWithoutTime(ticket["ticketData"].expected_arrival_date),
            closed_he : this.utilService.convertDateHebrew(ticket["status"] == 1 ? '' : (byStatus["4"] ? byStatus["4"][0].action_time : '')),
            created_DateTime_value : moment(ticket["ticket_id_info"][0].action_time).format("YYYY-MM-DD HH:mm:ss").valueOf(),
            closed_DateTime_value : ticket["status"] == 1 ? '' : (byStatus["4"] ? byStatus["4"][0].action_time : ''),
            created_convertDateEnglish : this.utilService.convertDateEnglish(ticket["ticket_id_info"][0].action_time),
            created_convertDateHebrew : this.utilService.convertDateHebrew(ticket["ticket_id_info"][0].action_time),
            bin_location : ticket["status"] == 1 ? '' : byStatus[4][0].installed_lat + "," + byStatus["1"][0].installed_lon,
            binNeighborhood : ticket["status"] == 1 ? '' : byStatus[4][byStatus[4].length - 1].installed_bin_neighborhood ? byStatus[4][byStatus[4].length - 1].installed_bin_neighborhood : '',
            is_installed : ticket["status"] == 1 ? '' : byStatus[4][0].is_installed,
            assigned_user_first_name : byStatus["1"] ? byStatus["1"][byStatus["1"].length - 1].assigned_user_first_name : '',
				    assigned_user_last_name : byStatus["1"] ? byStatus["1"][byStatus["1"].length - 1].assigned_user_last_name : ''
          };
        }else if(ticket_event_type_id == 4){
          return {
            ticket_type : ticket["ticketData"].ticket_event_type_name,
            ticket_id : ticket["ticket_id"],
            status_txt : ticket["status"] == 1 ? this.translationsObj.TICKET_MANAGEMENT.OPENED : ticket["status"] == 3 ? this.translationsObj.TICKET_MANAGEMENT.ON_HOLD_STATUS : this.translationsObj.TICKET_MANAGEMENT.CLOSED_STATUS,
            eventCauseEn : ticket["ticketData"].ticket_event_cause_name,
            priorityEn : ticket["ticketData"].priority_name,
            site_name : ticket["site_name"],
            bin_name : ticket["status"] == 1 ? (byStatus["1"] ? (ticket["ticketData"].ticket_event_type_id == 3 ? byStatus["1"][byStatus["1"].length - 1].installed_bin_name : byStatus["1"][byStatus["1"].length - 1].bin_name) : '') : ticket["status"] == 3 ? (byStatus["3"] ? (ticket["ticketData"].ticket_event_type_id == 3 ? byStatus["3"][byStatus["3"].length - 1].installed_bin_name : byStatus["3"][byStatus["3"].length - 1].bin_name) : '') : (byStatus["4"] ? (ticket["ticketData"].ticket_event_type_id == 3 ? byStatus["4"][byStatus["4"].length - 1].installed_bin_name : byStatus["4"][byStatus["4"].length - 1].bin_name) : ''),
            bin_address : ticket["status"] == 1 ? (byStatus["1"] ? (ticket["ticketData"].ticket_event_type_id == 3 ? byStatus["1"][byStatus["1"].length - 1].installed_bin_address : byStatus["1"][byStatus["1"].length - 1].bin_address) : '') : ticket["status"] == 3 ? (byStatus["3"] ? (ticket["ticketData"].ticket_event_type_id == 3 ? byStatus["3"][byStatus["3"].length - 1].installed_bin_address : byStatus["3"][byStatus["3"].length - 1].bin_address) : '') : (byStatus["4"] ? (ticket["ticketData"].ticket_event_type_id == 3 ? byStatus["4"][byStatus["4"].length - 1].installed_bin_address : byStatus["4"][byStatus["4"].length - 1].bin_address) : ''),
            comment : byStatus["1"] ? byStatus["1"][byStatus["1"].length - 1].comment : '',
            assignee : byStatus["1"] ? byStatus["1"][byStatus["1"].length - 1].assigned_user_first_name + " " + byStatus["1"][byStatus["1"].length - 1].assigned_user_last_name : '',
            reporter : byStatus["1"] ? byStatus["1"][0].user_first_name + " " + byStatus["1"][0].user_last_name: this.translationsObj.TICKET_MANAGEMENT.AUTOMATIC_TICKET,
            created : this.utilService.convertDateEnglishWithoutTime(ticket["ticket_id_info"][0].action_time),
            expected_arrival_date : this.utilService.convertDateEnglishWithoutTime(ticket["ticketData"].expected_arrival_date),
            closed : this.utilService.convertDateEnglish(ticket["status"] == 1 ? '' : (byStatus["4"] ? byStatus["4"][0].action_time : '')),
            reasonOfReplacementEn : byStatus["4"] ? byStatus[4][byStatus[4].length - 1].ticket_remove_replace_cause_name : '',            
            resolvedDescription : byStatus["4"] ? byStatus["4"][byStatus["4"].length - 1].comment : '',
            reasonOfReplacementHe : byStatus["4"] ? byStatus[4][byStatus[4].length - 1].ticket_remove_replace_cause_name_hebrew : '', 
            solution_time : moment(moment(byStatus["4"] ? byStatus["4"][0].action_time : '').format('YYYY-MM-DD HH:mm:ss')).diff(moment(ticket["ticket_id_info"][0].action_time).format('YYYY-MM-DD HH:mm:ss'), 'days'),
            eventCauseHe : ticket["ticketData"].ticket_event_cause_name_hebrew,
            priorityHe : ticket["ticketData"].priority_name_hebrew,
            site_id : ticket["site_id"],
            ticket_event_cause_id : ticket["ticketData"].ticket_event_cause_id,
            priority_id : ticket["ticketData"].priority_id,
            ticket_event_type_id : ticket["ticketData"].ticket_event_type_id,
            ticketInfo : ticket["ticket_id_info"],
            pic_url : ticket["ticketData"].pic_url,
            first_name : byStatus["1"] ? byStatus["1"][0].user_first_name : '',
            last_name : byStatus["1"] ? byStatus["1"][0].user_last_name: '',
            user_id : ticket["status"] == 1 ? (byStatus["1"] ? byStatus["1"][byStatus["1"].length - 1].user_id: '') : (byStatus["4"] ? byStatus["4"][byStatus["4"].length - 1].user_id : ''),
            bin_id : ticket["bin_id"],
            eventTypeEn : ticket["ticketData"].ticket_event_type_name,
            eventTypeHe : ticket["ticketData"].ticket_event_type_name_hebrew,
            status : ticket["status"],
            bin_lat : ticket["bin_lat"],
            bin_lon : ticket["bin_lon"],
            ticket_type_hebrew : ticket["ticketData"].ticket_event_type_name_hebrew,
            bin_collection_mode : ticket["bin_collection_mode"],
            created_he : this.utilService.convertDateHebrewWithoutTime(ticket["ticket_id_info"][0].action_time),
            expected_arrival_date_he : this.utilService.convertDateHebrewWithoutTime(ticket["ticketData"].expected_arrival_date),
            closed_he : this.utilService.convertDateHebrew(ticket["status"] == 1 ? '' : (byStatus["4"] ? byStatus["4"][0].action_time : '')),
            created_DateTime_value : moment(ticket["ticket_id_info"][0].action_time).format("YYYY-MM-DD HH:mm:ss").valueOf(),
            closed_DateTime_value : ticket["status"] == 1 ? '' : (byStatus["4"] ? byStatus["4"][0].action_time : ''),
            created_convertDateEnglish : this.utilService.convertDateEnglish(ticket["ticket_id_info"][0].action_time),
            created_convertDateHebrew : this.utilService.convertDateHebrew(ticket["ticket_id_info"][0].action_time),
            is_removed_from_bin : ticket["status"] == 1 ? '' : byStatus[4]?.[byStatus[4]?.length - 1]?.is_removed_from_bin,
            is_removed_from_site : ticket["status"] == 1 ? '' : byStatus[4]?.[byStatus[4]?.length - 1]?.is_removed_from_site,
            is_replaced : ticket["status"] == 1 ? '' : byStatus[4]?.[byStatus[4]?.length - 1]?.is_replaced,
            assigned_user_first_name : byStatus["1"] ? byStatus["1"][byStatus["1"].length - 1].assigned_user_first_name : '',
				    assigned_user_last_name : byStatus["1"] ? byStatus["1"][byStatus["1"].length - 1].assigned_user_last_name : ''
          };
        }
      });	
  
      this.technicianTickets = technicianTicketsFiltered;		
  
      this.sortTechnicianTicketsData({ direction: 'desc', active: 'created_DateTime_value' });
      this.sortTechnicianTicketsData({ direction: 'asc', active: 'status' });
      this.updateTechnicianData();
  
      this.openedTickets = this.openedTickets.concat(_.groupBy(this.technicianTickets, "status")["1"],_.groupBy(this.technicianTickets, "status")["1"],_.groupBy(this.technicianTickets, "status")["1"]);
      this.closedTickets = this.closedTickets.concat(_.groupBy(this.technicianTickets, "status")["4"],_.groupBy(this.technicianTickets, "status")["4"],_.groupBy(this.technicianTickets, "status")["4"]);
  
      if(!_.isEmpty(this.apiStore.getValue()["selectedTicket"]) && this.openedTickets.length > 0 && !this.isResolveDialogOpen){			
      const relevantTicket = _.filter(this.openedTickets, (res) => {   
        if(res){
          return res["ticket_id"] == this.apiStore.getValue()["selectedTicket"]["ticket_id"];
        }   
      }); 	
        this.dialog.closeAll();
        if(relevantTicket.length > 0){
        this.isResolveDialogOpen = true;
        this.resolveAction(relevantTicket[0]);
        // Clear selectedTicket from store to prevent reopening
        this.apiStore.update({ selectedTicket: null });
        }
      }	
  
      if(this.ticketId && cRTicketsList.length != 0 && insTicketsList.length != 0 && rmTicketsList.length != 0 && this.closedTickets.length > 0){
        const relevantTicket = _.filter(this.closedTickets, (res) => {      
          return res["ticket_id"] == this.ticketId;
        });  
        this.dialog.closeAll();
        if(relevantTicket.length > 0){
        if(relevantTicket[0]["ticket_event_type_id"] == 1){
          this.viewAction(relevantTicket[0]);
        }else if(relevantTicket[0]["ticket_event_type_id"] == 3){
          this.viewAction(relevantTicket[0]);
        }else if(relevantTicket[0]["ticket_event_type_id"] == 4){
          this.viewAction(relevantTicket[0]);
        }
        }
      }
    })
  }

  ngOnDestroy() {
    sessionStorage.removeItem('ticketManagementMinDate');
    sessionStorage.removeItem('ticketManagementMaxDate');
    this.isResolveDialogOpen = false;
    this.destroy$.next();
    this.destroy$.complete();
  }

  sortTechnicianTicketsData(sort: Sort) {
    const data = this.technicianTickets.slice();
    if (!sort.active || sort.direction === '') {
      this.technicianTickets = data;
      this.updateTechnicianData();
      return;
    }
    this.technicianTickets = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      return sort.active ? this.compare(a[sort.active], b[sort.active], isAsc) : 0;
    });
    this.updateTechnicianData();
  }
  
  viewAction(item){
    this.dialog.open(ViewTicketModal, { panelClass: 'bulkBins-container' , data: {chosenTicket : item} });
  }

  compare(a, b, isAsc) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  resolveAction(item){	
    let class_name = '';
    if(this.isMobile){
      class_name = 'popup-container-mobile';
    }else{
      class_name = 'bulkBins-container';
    }
    const dialogRef = this.dialog.open(ResolveTicketModal, { panelClass: class_name , data: {chosenTicket : item} });
    
    // Reset flag when dialog is closed
    dialogRef.afterClosed().subscribe(() => {
      this.isResolveDialogOpen = false;
    });
  }

  getRelevantBin(binsLookup: Map<string, any>, ticket: any, status: string): void {
    const statusInfo = _.groupBy(ticket["ticket_id_info"], "status_id")[status];
    if (!statusInfo || !statusInfo.length) return;
    const lastInfo = statusInfo[statusInfo.length - 1];
    if (ticket["ticketData"].ticket_event_type_id == 3) {
      if (lastInfo.installed_bin_name != null && lastInfo.installed_bin_name !== '') {
        const relevantBin = binsLookup.get(`${ticket.site_id}|${lastInfo.installed_bin_name}`);
        if (relevantBin) {
          ticket.bin_id = relevantBin["bin_id"];
          ticket.bin_lat = relevantBin["bin_latitude"] ?? relevantBin["bin_lat"];
          ticket.bin_lon = relevantBin["bin_longitude"] ?? relevantBin["bin_lon"];
          ticket.bin_collection_mode = relevantBin["bin_collection_mode"];
        } else {
          ticket.bin_id = '';
          ticket.bin_lat = 0.00000000;
          ticket.bin_lon = 0.00000000;
          ticket.bin_collection_mode = 0;
        }
      } else {
        ticket.bin_id = '';
        ticket.bin_lat = lastInfo.installed_lat;
        ticket.bin_lon = lastInfo.installed_lon;
        ticket.bin_collection_mode = 0;
      }
    } else {
      ticket.bin_id = lastInfo.bin_id;
      ticket.bin_lat = lastInfo.bin_lat;
      ticket.bin_lon = lastInfo.bin_lon;
      ticket.bin_collection_mode = 0;
    }
  }

  private buildBinsLookup(bins: any[]): Map<string, any> {
    const map = new Map<string, any>();
    if (!bins || !bins.length) return map;
    for (const bin of bins) {
      const key = `${bin.site_id}|${bin.bin_name}`;
      if (!map.has(key)) map.set(key, bin);
    }
    return map;
  }

  onResize() {
    this.responsiveService.getMobileStatus().subscribe(isMobile => {
      this.isMobile = isMobile;
    });
  }

  applyTechnicianFilter = (filterValue: string) => {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.tempTechnicianTicketsFilter = filterValue;
    this.updateTechnicianData();
  }

  handleMarkerSelected(event){
    this.markerSelected = event;
    if(this.expandedElementTable["ticket_id"] != this.markerSelected["ticket_id"]){
      this.expandedElementTable = this.markerSelected;
    }
    const technicianTicketsMarker = _.filter(this.technicianTickets, (res) => {      
          return res["ticket_id"] == this.markerSelected["ticket_id"];
    }); 

    let index = this.filteredTechnicianTicketsData.findIndex(item => item["ticket_id"] === technicianTicketsMarker[0]["ticket_id"]);
    let pageNumber = Math.floor(index / 10) + 1;
    let pageIndexes = {
      startIndex : pageNumber * 10 - 10,
      endIndex : pageNumber * 10 - 1
    }
    this.onTechnicianPageChange(pageIndexes);
  }

  handleMarkerDeselected(){
    this.markerSelected = {};
    this.expandedElementTable = {};
  }

  openAddTicket(){
    let class_name = '';
    if(this.isMobile){
      class_name = 'popup-container-mobile';
    }else{
      class_name = 'bulkBins-container';
    }
    const dialogRef = this.dialog.open(AddTicketModal, { panelClass: class_name });
  }

  deleteOwnEvent(event){
    if(event.user_id == this.user_id && this.user_role_id == 4){
      return true;
    }else{
      return false;
    }
  }

  onTechnicianPageChange = (dataTableIndexes: any) => {
    this.startIndexTableDataTechnicianTickets = dataTableIndexes.startIndex;
    this.endIndexTableDataTechnicianTickets = dataTableIndexes.endIndex;
    this.updateTechnicianData();
  }

  deleteAction(item,status){	
    const request = {   
      "event_cause_id": item.ticket_event_cause_id,
      "event_type_id":item.ticket_event_type_id,
      "priority_id":item.priority_id,
      "ticket_id":item.ticket_id,
      "comment":_.groupBy(item["ticketInfo"], "status_id")[status] ? _.groupBy(item["ticketInfo"], "status_id")[status][0]["comment"] : '',
      "status_id":5,
      "site_id":item.site_id,
      "expected_arrival_date":item.expected_arrival_date
      }
      
      if(item.ticket_event_type_id == "1"){
      request["bin_id"] = _.groupBy(item["ticketInfo"], "status_id")[status][0].bin_id;
      request["analysis_id"] = _.groupBy(item["ticketInfo"], "status_id")[status][0].analysis_id;
      request["ticket_remove_replace_cause_id"] = _.groupBy(item["ticketInfo"], "status_id")[status][0].replace_cause_id ? _.groupBy(item["ticketInfo"], "status_id")[status][0].replace_cause_id : 0;
      request["is_replaced"] = _.groupBy(item["ticketInfo"], "status_id")[status][0].is_replaced;
      }else if(item.ticket_event_type_id == "3"){
      request["is_installed"] = _.groupBy(item["ticketInfo"], "status_id")[status][0].is_installed;
      request["bin_install_address"] = _.groupBy(item["ticketInfo"], "status_id")[status][0].installed_bin_address;
      request["lat"] = _.groupBy(item["ticketInfo"], "status_id")[status][0].installed_lat;
      request["lon"] = _.groupBy(item["ticketInfo"], "status_id")[status][0].installed_lon;
      request["installation_type_id"] = 0;
      request["installed_bin_neighborhood"] = _.groupBy(item["ticketInfo"], "status_id")[status][0].installed_bin_neighborhood;
      }else if(item.ticket_event_type_id == "4"){
      request["bin_id"] = _.groupBy(item["ticketInfo"], "status_id")[status][0].bin_id;
      request["is_removed_from_bin"] = _.groupBy(item["ticketInfo"], "status_id")[status][0].is_removed_from_bin;
      request["is_removed_from_site"] = _.groupBy(item["ticketInfo"], "status_id")[status][0].is_removed_from_site;
      request["ticket_remove_replace_cause_id"] = _.groupBy(item["ticketInfo"], "status_id")[status][0].replace_cause_id ? _.groupBy(item["ticketInfo"], "status_id")[status][0].replace_cause_id : 0;
      }
      
      this.apiService.insertNewTicket(request).subscribe((v:any) => {     				
      let ticketManagementRequest = {};   
      if(sessionStorage.getItem("ticketManagementMinDate") == '' || sessionStorage.getItem("ticketManagementMaxDate") == '' || 
      sessionStorage.getItem("ticketManagementMinDate") == null || sessionStorage.getItem("ticketManagementMaxDate") == null){
        ticketManagementRequest = {
          status_id : -1
          }
      }else{
        ticketManagementRequest = {
          start_time : sessionStorage.getItem("ticketManagementMinDate"),
          end_time : sessionStorage.getItem("ticketManagementMaxDate")
          }
      }				
  
      this.apiStore.update({ allCRTicketsList: [] });
      this.apiStore.update({ cRTicketsList: [] });
      this.apiService.getCRTicketsList(ticketManagementRequest,JSON.parse(sessionStorage.getItem("chosenSites")));
  
      this.apiStore.update({ allInsTicketsList: [] });
      this.apiStore.update({ insTicketsList: [] });
      this.apiService.getInsTicketsList(ticketManagementRequest,JSON.parse(sessionStorage.getItem("chosenSites")));
  
      this.apiStore.update({ allRmTicketsList: [] });
      this.apiStore.update({ rmTicketsList: [] });
      this.apiService.getRmTicketsList(ticketManagementRequest,JSON.parse(sessionStorage.getItem("chosenSites")));
  
      this.apiStore.update({ allTicketsList: [] });
      this.apiStore.update({ ticketsList: [] });
      this.apiService.getTicketsList(JSON.parse(sessionStorage.getItem("chosenSites")));
  
      this.apiService.getfilteredBinsInfo(JSON.parse(sessionStorage.getItem("chosenSites")));
  
      this.apiStore.update({ allFilteredBasicBins: [] });                    
      this.apiStore.update({ filteredBasicBins: [] }); 
      this.apiService.getfilteredBasicBinsInfo(JSON.parse(sessionStorage.getItem("chosenSites")));
      });
  }

  openElementBinInfo(el) {
    let class_name = '';
    let selectedElements = [];
    if(this.isMobile){
      class_name = 'popup-container-mobile';
    }else{
      class_name = this.currentLang != "iw" ? "clusterInfo-container-ltr" : "clusterInfo-container-rtl";
    }
  
    selectedElements = [el];
  
    // Check if dialog is already open (using static property for cross-page support)
    if(BinLiveInfoModal.openModalRef && BinLiveInfoModal.openModalRef.componentInstance && !BinLiveInfoModal.openModalRef.componentInstance.dialogRef.closed) {
      // Dialog is already open, add tabs to existing modal
      BinLiveInfoModal.openModalRef.componentInstance.addTabs(selectedElements);
      return;
    }
  
    const dialogRef = this.dialog.open(BinLiveInfoModal, {
      panelClass: class_name,
      width: '55%',
      data: {
        item: selectedElements
      },
    });
  
    // Set static reference for cross-page access
    BinLiveInfoModal.openModalRef = dialogRef;
  
    // Clear reference when dialog is closed
    dialogRef.afterClosed().subscribe(() => {
      BinLiveInfoModal.openModalRef = null;
    });
  }

  openTechnicianColumnManaging(){
    const dialogRef = this.dialog.open(GenericColumnsManagingModal, { panelClass: 'popup-container-mobile' , data: {page : 'ticketManagementCancellation', displayedColumns: this.ticketManagementTechnicianTicketsSelectedValues} });
		dialogRef.afterClosed().subscribe(result => {
			this.ticketManagementTechnicianTicketsSelectedValues  = result.values;
			if (!_.isEmpty(this.ticketManagementTechnicianTicketsSelectedValues)) {
				//init table with the new columns
				this.initTables();		
			}
		});
  }	

  expandTechnicianTicketsMap(){
    this.mapTechnicianExpanded = !this.mapTechnicianExpanded;
  }

  private updateTechnicianData(): void {
    const tableData = [];
    this.applyCurrentTechnicianTicketsFilter();
    const sourceData = this.currentFilteredTechnicianTicketsArr ?? this.technicianTickets;
    const tempSearch = new MatTableDataSource<any>(sourceData);
    tempSearch.filter = this.tempTechnicianTicketsFilter;
    this.filteredTechnicianTicketsData = tempSearch.filteredData;
    this.technicianTicketsTableLength = this.filteredTechnicianTicketsData.length;
    this.technicianTickets$.next(this.filteredTechnicianTicketsData);
    for (let index = this.startIndexTableDataTechnicianTickets; index <= this.endIndexTableDataTechnicianTickets; index++) {
      if (tempSearch.filteredData[index]) {
        tableData.push(tempSearch.filteredData[index]);
      }
    }
    this.technicianTicketsDataSource = tableData.length > 0 ? new MatTableDataSource<any>(tableData) : new MatTableDataSource<any>([]);
    this.technicianTicketsDataSource.sort = this.sort;
  }

  editAction(item){
    let class_name = '';
    if(this.isMobile){
      class_name = 'popup-container-mobile';
    }else{
      class_name = 'bulkBins-container';
    }
    const dialogRef = this.dialog.open(EditTicketModal, { panelClass: class_name , data: {chosenTicket : item,reopen:false} });
  }

  filterStatusHandler(event:any){
		this.currentTechnicianTicketsFilterValues = event;
		this.startIndexTableDataTechnicianTickets = 0;
		this.endIndexTableDataTechnicianTickets = 9;
		this.updateTechnicianData();
	}

	private applyCurrentTechnicianTicketsFilter(){
		const filterValues = this.currentTechnicianTicketsFilterValues;
		const hasEventCauseFilter = filterValues && filterValues.eventCause && filterValues.eventCause.length > 0;
		const hasTicketTypeFilter = filterValues && filterValues.ticketType && filterValues.ticketType.length > 0;
		const hasStatusFilter = filterValues && filterValues.status && filterValues.status.length > 0;

		if(hasEventCauseFilter || hasTicketTypeFilter || hasStatusFilter){
			this.currentFilteredTechnicianTicketsArr = this.technicianTickets.filter(ticket => 
				(hasEventCauseFilter ? filterValues.eventCause.includes(ticket['eventCauseEn']) : true) &&
				(hasTicketTypeFilter ? filterValues.ticketType.includes(ticket['ticket_type']) : true) &&
				(hasStatusFilter ? filterValues.status.includes(ticket['status']) : true)
			);
		}else{
			this.currentFilteredTechnicianTicketsArr = null;
		}
	}

  reopenAction(item){
    let class_name = '';
    if(this.isMobile){
      class_name = 'popup-container-mobile';
    }else{
      class_name = 'bulkBins-container';
    }
    const dialogRef = this.dialog.open(EditTicketModal, { panelClass: class_name , data: {chosenTicket : item,reopen:true} });
  }

  /** '' / null when the ticket carries no removal data, otherwise Yes or No. Written
      this way because 0 != '' is false in JS, which exported a blank instead of "No". */
  private removalFlagToText(flag: any): string {
    if(flag === '' || flag === null || flag === undefined){
      return '';
    }
    return Number(flag) === 1 ? this.translationsObj.OTHER.YES : this.translationsObj.OTHER.NO;
  }

  /** DB-5197: nothing to export while the filtered events table is empty. */
  get isExportDisabled(): boolean {
    return (this.filteredTechnicianTicketsData?.length ?? 0) === 0;
  }

  exportToCsv(){
    // DB-5197: the button is shown greyed out; ignore the click rather than write an empty file.
    if(this.isExportDisabled){
      return;
    }
    let dataToExport = null;
    dataToExport = _.cloneDeep(this.filteredTechnicianTicketsData);
    
    _.each(dataToExport, (item) => {
      if(this.currentLang == 'iw'){
        item.ticket_type = item.ticket_type_hebrew;
        item.eventCauseEn = item.eventCauseHe;
        item.priorityEn = item.priorityHe;
        item.created = item.created_he;
        item.expected_arrival_date = item.expected_arrival_date_he;
        item.closed = item.closed_he;
        if(item.ticket_event_type_id == 1){
          if(item.is_replaced != ''){
            item.is_replaced_csv = item.is_replaced == 1 ? this.translationsObj.TICKET_MANAGEMENT.REPLACED : this.translationsObj.TICKET_MANAGEMENT.NOT_REPLACED;
          }
          item.reasonOfReplacementEn = item.reasonOfReplacementHe;
          item.analysisNameEn = item.analysisNameHe;
        }
      }else{
        if(item.is_replaced != ''){
          item.is_replaced_csv = item.is_replaced == 1 ? this.translationsObj.TICKET_MANAGEMENT.REPLACED : this.translationsObj.TICKET_MANAGEMENT.NOT_REPLACED;
        }
      }
      if(item.assigned_user_first_name == null || item.assigned_user_last_name == null){
        item.assignee = '';
      }

      // Removal details (DB-6381), matching the Ticket Management export. Built for every
      // row so the shared header lines up: an event type that carries no removal data
      // simply exports an empty cell.
      item.is_removed_from_bin_csv = this.removalFlagToText(item.is_removed_from_bin);
      item.is_removed_from_site_csv = this.removalFlagToText(item.is_removed_from_site);
      item.removed_reason_csv = this.currentLang == 'iw'
        ? (item.reasonOfReplacementHe || '')
        : (item.reasonOfReplacementEn || '');
    });
  
    // The two removal flags are only meaningful for removal tickets, so they are added
    // to the file only when at least one removal ticket is actually being exported.
    const hasRemovalTickets = _.some(dataToExport, (item: any) => item.ticket_event_type_id == 4);

    let header: any = {};
    header = {
      '0' : this.translationsObj.TICKET_MANAGEMENT.EVENT_TYPE,
      '1' : this.translationsObj.TICKET_MANAGEMENT.EVENT_ID,
      '2' : this.translationsObj.TICKET_MANAGEMENT.STATUS,
      '3' : this.translationsObj.TICKET_MANAGEMENT.EVENT_CAUSE, 
      '4' : this.translationsObj.TICKET_MANAGEMENT.PRIORITY,
      '5' : this.translationsObj.TICKET_MANAGEMENT.SITE,
      '6' : this.translationsObj.TICKET_MANAGEMENT.BIN_NAME, 
      '7' : this.translationsObj.TICKET_MANAGEMENT.BIN_ADDRESS, 
      '8' : this.translationsObj.TICKET_MANAGEMENT.EVENT_DESCRIPTION,
      '9' : this.translationsObj.TICKET_MANAGEMENT.ASSIGNEE,
      '10' : this.translationsObj.TICKET_MANAGEMENT.REPORTER,
      '11' : this.translationsObj.TICKET_MANAGEMENT.CREATED,
      '12' : this.translationsObj.TICKET_MANAGEMENT.EXPECTED_ARRIVAL_DATE,
      '13' : this.translationsObj.TICKET_MANAGEMENT.CLOSED
    }  

    if(hasRemovalTickets){
      header['14'] = this.translationsObj.TICKET_MANAGEMENT.UNIT_IS_CANCELED;
      header['15'] = this.translationsObj.TICKET_MANAGEMENT.UNIT_REMOVED_FROM_SITE;
      header['16'] = this.translationsObj.TICKET_MANAGEMENT.REMOVED_REASON;
    }else{
      header['14'] = this.translationsObj.TICKET_MANAGEMENT.REMOVED_REASON;
    }
  
    /* This list mixes event types and each type builds a differently shaped row, so
       slicing the first N values put a different field under the same header depending
       on the type. The columns are taken by name instead, in header order. */
    const exportColumns = ['ticket_type','ticket_id','status_txt','eventCauseEn','priorityEn',
      'site_name','bin_name','bin_address','comment','assignee','reporter','created',
      'expected_arrival_date','closed'];

    if(hasRemovalTickets){
      exportColumns.push('is_removed_from_bin_csv','is_removed_from_site_csv');
    }
    exportColumns.push('removed_reason_csv');

    const flatData = dataToExport.reduce((b, a) => {	
      let res = exportColumns.map(column => a[column] != null ? a[column] : '');
      b.push(res);
      return b;
    }, [])
    
    let source = {
      flatData,
      header
    };	
  
    let result = source.flatData.map((details) => 
    Object.keys(details).reduce((a, b) => 
    (a[source.header[b]] = details[b], a), {}));			
    if(this.currentLang != 'iw'){
      TableUtil.exportArrayToExcel(result, "TicketManagment");
    }else{
      TableUtil.exportArrayToExcel(result, "ניהול אירועים");
    }
  }
}
